import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import { backDoorUnion } from '@my-pages/utils/backDoorUtils.ts';
import { useGetApiV2MemberUnionSuspense } from '@shared/integrations/taf-api/v2/features/member/member.ts';

const useGetUnion = () => {
    const backDoorEnabled = useApplicationStore((state) => state.backDoorEnabled);
    const { data } = backDoorEnabled ? { data: backDoorUnion } : useGetApiV2MemberUnionSuspense();

    return data;
};

export default useGetUnion;
